/**
 * PasswordGate — Handles password form submission via AJAX.
 * Also applies saved primary/accent colors to the gate element.
 */

export class PasswordGate {
  constructor( form ) {
    this.form  = form;
    this.error = form.querySelector( '#azleentv-gate-error' );
    this.btn   = form.querySelector( '.azleentv-gate-btn' );

    this._applyColors();
    this._bind();
  }

  /**
   * Apply saved colors from azleentvData to the gate CSS vars.
   */
  _applyColors() {
    if ( ! window.azleentvData ) return;
    const gate = this.form.closest( '.azleentv-password-gate' );
    if ( ! gate ) return;
    if ( window.azleentvData.primaryColor ) {
      gate.style.setProperty( '--atv-primary', window.azleentvData.primaryColor );
    }
    if ( window.azleentvData.accentColor ) {
      gate.style.setProperty( '--atv-accent', window.azleentvData.accentColor );
    }
  }

  _bind() {
    this.form.addEventListener( 'submit', ( e ) => {
      e.preventDefault();
      this._submit();
    } );
  }

  async _submit() {
    const password = this.form.querySelector( '#azleentv_password' );
    if ( ! password || ! window.azleentvData ) return;

    this._setLoading( true );
    this._clearError();

    const body = new FormData();
    body.append( 'action',   'azleentv_verify_password' );
    body.append( 'nonce',    window.azleentvData.nonce );
    body.append( 'password', password.value );

    try {
      const res  = await fetch( window.azleentvData.ajaxUrl, { method: 'POST', body } );
      const json = await res.json();

      if ( json.success && json.data.verified ) {
        window.location.reload();
      } else {
        this._showError( ( json.data && json.data.message ) || 'Incorrect password. Please try again.' );
      }
    } catch {
      this._showError( 'Network error. Please try again.' );
    } finally {
      this._setLoading( false );
    }
  }

  _setLoading( on ) {
    if ( this.btn ) {
      this.btn.disabled    = on;
      this.btn.textContent = on ? 'Verifying…' : 'Watch Now';
    }
  }

  _showError( msg ) {
    if ( this.error ) this.error.textContent = msg;
  }

  _clearError() {
    if ( this.error ) this.error.textContent = '';
  }
}
